export actions =
	nuxtServerInit: ({ dispatch }) ->
		await dispatch 'globals/fetch'
